import CompanySettings from '@/views/company-settings/Index.vue';
import CompanySettingsBilling from '@/views/company-settings/Billing.vue';
import CompanySettingsCompanyProfile from '@/views/company-settings/CompanyProfile.vue';
import CompanySettingsDeveloper from '@/views/company-settings/Developer.vue';
import CompanySettingsSecurity from '@/views/company-settings/Security.vue';
import CompanySettingsPreferences from '@/views/company-settings/Preferences.vue';
import CompanySettingsIntegrations from '@/views/company-settings/Integrations.vue';
import CompanySettingsData from '@/views/company-settings/Data.vue';

export default [
  {
    path: '/company-settings',
    name: 'CompanySettings',
    component: CompanySettings,
    meta: {
      title: 'companySettings',
      icon: 'cog',
      requiresAuth: true,
    },
    children: [
      {
        path: '/company-settings',
        redirect: '/company-settings/profile',
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/company-settings/profile',
        name: 'Company',
        component: CompanySettingsCompanyProfile,
        meta: {
          title: 'companySettings',
          icon: 'cog',
          requiresAuth: true,
        },
      },
      {
        path: '/company-settings/developer',
        name: 'Developer',
        component: CompanySettingsDeveloper,
        meta: {
          title: 'companySettings',
          icon: 'cog',
          requiresAuth: true,
        },
      },
      {
        path: '/company-settings/billing',
        name: 'Billing',
        component: CompanySettingsBilling,
        meta: {
          title: 'companySettings',
          icon: 'cog',
          requiresAuth: true,
        },
        props: true,
      },
      {
        path: '/company-settings/billing/annual-switch',
        redirect: {
          name: 'Billing',
          query: {
            select_annual: 'true',
          },
        },
      },
      {
        path: '/company-settings/security',
        name: 'Security',
        component: CompanySettingsSecurity,
        meta: {
          title: 'companySettings',
          icon: 'cog',
          requiresAuth: true,
        },
      },
      {
        path: '/company-settings/preferences',
        name: 'Preferences',
        component: CompanySettingsPreferences,
        meta: {
          title: 'companySettings',
          icon: 'cog',
          requiresAuth: true,
        },
      },
      {
        path: '/company-settings/integrations',
        name: 'Integrations',
        component: CompanySettingsIntegrations,
        meta: {
          title: 'companySettings',
          icon: 'cog',
          requiresAuth: true,
        },
      },
      {
        path: '/company-settings/integrations/:slug',
        name: 'ExchangeIntegrationToken',
        component: CompanySettingsIntegrations,
        meta: {
          title: 'companySettings',
          icon: 'cog',
          requiresAuth: true,
        },
      },
      {
        path: '/company-settings/data',
        name: 'Data',
        component: CompanySettingsData,
        meta: {
          title: 'companySettings',
          icon: 'cog',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/company-profile',
    redirect: '/company-settings',
    children: [
      {
        path: '/company-profile',
        redirect: '/company-settings/profile',
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/company-profile/company',
        redirect: '/company-settings/profile',
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/company-profile/developer',
        redirect: '/company-settings/developer',
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/company-profile/billing',
        redirect: '/company-settings/billing',
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/company-profile/billing/annual-switch',
        redirect: {
          name: 'Billing',
          query: {
            select_annual: 'true',
          },
        },
      },
      {
        path: '/company-profile/security',
        redirect: '/company-settings/security',
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/company-profile/preferences',
        redirect: '/company-settings/preferences',
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/company-profile/settings',
        redirect: '/company-settings/preferences',
      },
      {
        path: '/company-profile/integrations',
        redirect: '/company-settings/integrations',
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/company-profile/integrations/:slug',
        redirect: '/company-settings/integrations/:slug',
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/company-settings/data',
        redirect: '/company-settings/data',
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
];
